/**
 * Module for showing/hiding password fields. It hooks a button up to a password input field.
 * Usage:
 * <input type="password" name="password" id="password" class="form-control">
 * <button class="password-toggle js-password-toggle" aria-label="Show password"></button>
 */

document.addEventListener('DOMContentLoaded', () => {
  // Hook up show/hide password eye icon for all password toggles
  const passwordToggles = document.querySelectorAll('.js-password-toggle') as NodeListOf<HTMLButtonElement>;

  // Add event listeners
  passwordToggles.forEach((passwordToggle) => {
    passwordToggle.addEventListener('click', (e) => {
      // Stop it from auto-submitting the form
      e.preventDefault();

      // The password input needs to be the previous sibling of the button
      const password = passwordToggle.previousElementSibling as HTMLInputElement;
      const tooltip = (passwordToggle as any)._tippy; // Tippy instance, if it exists

      if (password.type === 'password') {
        password.type = 'text';
        passwordToggle.classList.add('password-toggle--hide');
        passwordToggle.setAttribute('aria-label', 'Hide password');
        if (tooltip) {
          tooltip.setContent('Hide password');
        }
      } else {
        password.type = 'password';
        passwordToggle.classList.remove('password-toggle--hide');
        passwordToggle.setAttribute('aria-label', 'Show password');
        if (tooltip) {
          tooltip.setContent('Show password');
        }
      }
    });
  });
});
